import React from 'react';
import Script from 'next/script';

const QumuScript: React.FC = () => {
  return (
    // eslint-disable-next-line @next/next/no-before-interactive-script-outside-document
    <Script src="https://abrdn.qumucloud.com/widgets/application.js" strategy="beforeInteractive" />
  );
};

export default QumuScript;
